import { default as MuiSelect, SelectProps } from '@mui/material/Select'
import React from 'react'

import { createComponentWrapperWithRef, styled, THEME_CONST, uiTokens } from '../../theme'
import { MsdkStyledComponent, OptionItem } from '../../utils'
import { Chip } from '../Chip'
import { OverflowList } from '../OverflowList'
import { OptionItemValue } from './OptionItemValue'

export { type SelectChangeEvent } from '@mui/material/Select'

const MuiBaseSelect = styled(MuiSelect)`
  border-radius: ${THEME_CONST.inputBorderRadius}px;
  width: 100%;
  align-items: stretch;
  padding-right: 0;

  .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputSizeSmall.MuiInputBase-inputAdornedEnd {
    padding: 8px 0 8px 14px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`

const NovaBaseSelect = styled(MuiSelect)`
  border-radius: ${uiTokens.radius.large}px;
  width: 100%;
  align-items: stretch;
  padding-right: 0;

  .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputSizeSmall.MuiInputBase-inputAdornedEnd {
    padding: 12px 0 8px 14px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`

export const BaseSelect = createComponentWrapperWithRef<SelectProps>(
  {
    mui: MuiBaseSelect,
    nova: NovaBaseSelect as React.ComponentType<SelectProps>,
    propsEnhancer(props, componentLibrary) {
      if (componentLibrary === 'nova') {
        props.MenuProps = props.MenuProps || {}
        props.MenuProps.slotProps = props.MenuProps.slotProps || {}
        props.MenuProps.slotProps.paper = {
          ...(typeof props.MenuProps.slotProps.paper === 'object' ? props.MenuProps.slotProps.paper : {}),
          sx: {
            ...(typeof props.MenuProps.slotProps.paper === 'object' && 'sx' in props.MenuProps.slotProps.paper
              ? props.MenuProps.slotProps.paper.sx
              : {}),
            borderRadius: `${uiTokens.radius.large}px`,
            paddingLeft: `${uiTokens.spacing.padding.small}px`,
            paddingRight: `${uiTokens.spacing.padding.small}px`,
          },
        }
      }
      return props
    },
  },
  'BaseSelect',
)

export const SelectInputAdornment: MsdkStyledComponent<any> = styled('div')`
  padding-right: 14px;
  display: flex;
  align-items: center;
`

const SelectOverflowList = styled(OverflowList)`
  gap: 4px;
` as typeof OverflowList

export const selectValueRenderer = (value: OptionItem | OptionItem[] | null, options?: OptionItem[]) => {
  if (!value) return
  if (Array.isArray(value)) {
    return (
      <SelectOverflowList<OptionItem>
        minVisibleItems={1}
        items={value}
        itemsRenderer={(items) =>
          items.map((v, i) => {
            const option = (options ?? []).find((op) => op.value === v.value) ?? v
            return (
              <OptionItemValue
                key={option.value}
                label={option.label}
                icon={option.icon}
                color={option.color}
                withSeparator={i < items.length - 1}
              />
            )
          })
        }
        overflowRenderer={(items) => {
          return items.length > 0 && <Chip variant="filled" size="small" label={`+${items.length}`}></Chip>
        }}
      />
    )
  }
  return <OptionItemValue label={value.label} icon={value.icon} color={value.color} />
}
